<ng-container *ngIf="isTranslationEnabled">

    <ng-container [ngSwitch]="template">

        <li *ngSwitchCase="'list-item'"
            [ngClass]="wrapperClass"
            [pTooltip]="languageToolTipContent"
            (click)="languagePopContent.show($event, container)">
            <a [ngClass]="buttonClass" class="d-flex align-items-center justify-content-center h-100" role="button">
                <fa-icon [icon]="['far', 'globe']" [ngClass]="buttonTextClass" size="lg"></fa-icon>
                <span *ngIf="showSelectedLanguage" class="ml-2 no-underline">{{ currentLanguageFull?.name }}</span>
            </a>
        </li>

        <div *ngSwitchCase="'button'" [ngClass]="wrapperClass">
            <button
                [ngClass]="buttonClass"
                [pTooltip]="languageToolTipContent"
                (mouseenter)="languagePopContent.show($event, container)"
                class="btn">
            <span [ngClass]="buttonTextClass">
                <fa-icon [icon]="['far', 'globe']"></fa-icon>
                <span *ngIf="showSelectedLanguage" class="ml-2 no-underline">{{ currentLanguageFull?.name }}</span>
            </span>
            </button>
        </div>

        <ng-container *ngSwitchCase="'select'">
            <select
                class="form-control clear-styles"
                tooltipPosition="right"
                [ngModel]="currentLanguageFull"
                (ngModelChange)="setLanguage($event, null)"
                pTooltip="{{ 'translation.language-picker.click-to-edit-your-language-here' | translate }}"
            >
                <option
                    *ngFor="let language of availableLanguages"
                    [ngValue]="language"
                    >
                    {{ language.name }}
                </option>
            </select>
        </ng-container>
    </ng-container>

    <p-overlayPanel #languagePopContent styleClass="language-popover">
        <ul class="list-group list-group-flush">
            <button
                (click)="setLanguage(language, languagePopContent); "
                *ngFor="let language of availableLanguages"
                [ngClass]="{'font-weight-bold': currentLanguage === language.key}"
                class="list-group-item list-group-item-action border-0"
                type="button"
            >
                <img *ngIf="showFlags"
                     [attr.alt]="language.name"
                     [src]="'https://cdn.qwyk.io/images/flags/r/' + (language.flag | lowercase) + '.svg'"
                     class="mr-2"
                     style="width: 16px; height: auto; margin-top: -2px;">
                {{ language.name }}
            </button>
        </ul>
    </p-overlayPanel>

    <ng-template #languageToolTipContent>
        <div>{{ 'translation.language-picker.tooltip' | translate }}</div>
        <div *ngIf="currentLanguage !== 'en'" class="small">(Change language)</div>
    </ng-template>

</ng-container>
